import React, { useState, useCallback, createContext, useContext } from "react";

// --- Toast Context ---
const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);

let toastId = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "info", duration = 3500) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);
  }, []);

  const toast = {
    success: (msg, dur) => addToast(msg, "success", dur),
    error: (msg, dur) => addToast(msg, "error", dur || 5000),
    info: (msg, dur) => addToast(msg, "info", dur),
    warn: (msg, dur) => addToast(msg, "warn", dur),
  };

  const icons = { success: "✅", error: "❌", info: "ℹ️", warn: "⚠️" };
  const colors = {
    success: { bg: "#052e16", border: "#16a34a", text: "#86efac" },
    error: { bg: "#2d0a0a", border: "#dc2626", text: "#fca5a5" },
    info: { bg: "#0d1f3c", border: "#3b82f6", text: "#93c5fd" },
    warn: { bg: "#2d1b00", border: "#d97706", text: "#fbbf24" },
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      {/* Toast Container */}
      <div style={{
        position: "fixed", bottom: "24px", right: "24px",
        display: "flex", flexDirection: "column", gap: "10px",
        zIndex: 99999, pointerEvents: "none"
      }}>
        {toasts.map(t => {
          const c = colors[t.type] || colors.info;
          return (
            <div key={t.id} style={{
              background: c.bg,
              border: `1px solid ${c.border}`,
              borderRadius: "12px",
              padding: "14px 18px",
              display: "flex", alignItems: "flex-start", gap: "10px",
              minWidth: "280px", maxWidth: "380px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
              animation: "toastSlideIn 0.3s ease",
              pointerEvents: "all",
              backdropFilter: "blur(8px)",
            }}>
              <span style={{ fontSize: "16px", flexShrink: 0, marginTop: "1px" }}>{icons[t.type]}</span>
              <span style={{ fontSize: "13px", fontWeight: 600, color: c.text, lineHeight: "1.4", wordBreak: "break-word" }}>
                {t.message}
              </span>
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes toastSlideIn {
          from { opacity: 0; transform: translateX(30px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
